global.constants = {
    isMobile:navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
    // channel:"mengduo", 
    //梦多
    channel:"hongchuang"
    // 红创
};


// WEBPACK FOOTER //
// ./src/config.js